export default __webpack_public_path__ + "static/media/friendly-matches.d22a705d.png";